import { Menu } from "antd";
import { useEffect, useState } from "react";
//@ts-ignore: Css import issues
import "./MainLayout.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../Context/UserContext";
import {
  BookOutlined,
  DiffOutlined,
  HolderOutlined,
  IdcardOutlined,
  LayoutOutlined,
  ProfileOutlined,
  ScheduleOutlined,
  SettingOutlined,
  ShopOutlined,
  ToolOutlined,
  SyncOutlined,
  FileOutlined,
  CloudDownloadOutlined,
  FileTextOutlined,
  SnippetsOutlined,
  CloudOutlined,
  DeliveredProcedureOutlined,
  BarChartOutlined,
  RocketOutlined,
  CalendarOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
// import { useCompany } from "../Context/CompanyContext";

const Sidemenus: React.FC<{
  isCollapse: any;
  onsetSlide: any;
  styles: any;
  isSlide: any;
}> = (props: any) => {
  let loc = useLocation();
  const {
    isAuthenticated,
    isSuperAdmin,
    isSubAdmin,
    isSupportUser,
    isSupportManager,
    isSupportAdmin,
    isSupport,
  } = useUser();
  const hasSupportAccess = () =>
    isSubAdmin() ||
    isSuperAdmin() ||
    isSupportUser() ||
    isSupportManager() ||
    isSupportAdmin() ||
    (isSupport && isSupport());
  // const { isFeatureExists } = useCompany();
  const [current, setCurrent] = useState(
    loc.pathname === "/" ? "/" : `/${loc.pathname.split("/")[1]}`,
  );
  useEffect(() => {
    if (loc) {
      if (current !== loc.pathname) {
        setCurrent(`/${loc.pathname.split("/")[1]}`);
      }
    }
  }, [loc, current]);
  const navigate = useNavigate();
  const setSelectedMenuItem = (key: any) => {
    if (key) {
      navigate(key);
      props.onsetSlide(false);
      setCurrent(key);
    }
  };

  return (
    <>
      {isAuthenticated() ? (
        <Menu
          theme="light"
          style={props?.isSlide && props?.styles}
          mode="inline"
          inlineCollapsed={props.isCollapse}
          className="sidebar"
          defaultSelectedKeys={[current]}
          selectedKeys={[current]}
          onClick={(e) => setSelectedMenuItem(e.key)}
          items={[
            // --- Overview ---
            isSubAdmin() || isSuperAdmin()
              ? {
                  type: "group" as const,
                  label: "Overview",
                  children: [
                    {
                      key: "/dashboard",
                      icon: <LayoutOutlined />,
                      label: <Link to="/dashboard">Dashboard</Link>,
                    },
                    {
                      key: "/practices",
                      icon: <ShopOutlined />,
                      label: <Link to="/practices">Practices</Link>,
                    },
                  ],
                }
              : null,

            // --- Support ---
            hasSupportAccess()
              ? {
                  type: "group" as const,
                  label: "Support",
                  children: [
                    {
                      key: "/tickets",
                      icon: <SyncOutlined />,
                      label: <Link to="/tickets">Support tickets</Link>,
                    },
                    ...(isSuperAdmin() || isSubAdmin() || isSupportAdmin()
                      ? [
                          {
                            key: "/ticket-alert-templates",
                            icon: <FileOutlined />,
                            label: (
                              <Link to="/ticket-alert-templates">
                                Ticket alert templates
                              </Link>
                            ),
                          },
                        ]
                      : []),
                  ],
                }
              : null,

            // --- Operations ---
            isSubAdmin() || isSuperAdmin()
              ? {
                  type: "group" as const,
                  label: "Operations",
                  children: [
                    {
                      key: "/updates",
                      icon: <RocketOutlined />,
                      label: <Link to="/updates">Releases</Link>,
                    },
                    {
                      key: "/holidays",
                      icon: <CalendarOutlined />,
                      label: <Link to="/holidays">Bank Holidays</Link>,
                    },
                    ...(isSuperAdmin() ? [
                      {
                        key: "/practice-data-requests",
                        icon: <UsergroupAddOutlined />,
                        label: (
                          <Link to="/practice-data-requests">
                            Practice Onboarding
                          </Link>
                        ),
                      },
                    ] : []),
                  ],
                }
              : null,

            // --- Configuration ---
            isSubAdmin() || isSuperAdmin()
              ? {
                  type: "group" as const,
                  label: "Configuration",
                  children: [
                    {
                      key: "/ctconfiguration",
                      icon: <ScheduleOutlined />,
                      label: (
                        <Link to="/ctconfiguration">CT Configuration</Link>
                      ),
                    },
                    {
                      key: "/payrollyearlysettings",
                      icon: <DiffOutlined />,
                      label: (
                        <Link to="/payrollyearlysettings">
                          Payroll Yearly Settings
                        </Link>
                      ),
                    },
                  ],
                }
              : null,

            // --- Setting ---
            isSuperAdmin() || isSubAdmin() || isSupportAdmin()
              ? {
                  type: "group" as const,
                  label: "Setting",
                  children: [
                    {
                      key: "/adminusers",
                      icon: <IdcardOutlined />,
                      label: <Link to="/adminusers">Users</Link>,
                    },
                    ...(isSuperAdmin()
                      ? [
                          {
                            key: "/super-admin-logs",
                            icon: <ProfileOutlined />,
                            label: (
                              <Link to="/super-admin-logs">Admin logs</Link>
                            ),
                          },
                        ]
                      : []),
                  ],
                }
              : null,

            // --- Admin ---
            isSuperAdmin()
              ? {
                  type: "group" as const,
                  label: "Admin",
                  children: [
                    {
                      key: "/submissionhold",
                      icon: <HolderOutlined />,
                      label: <Link to="/submissionhold">Submission Hold</Link>,
                    },
                    {
                      key: "/generalsettingbooks",
                      icon: <BookOutlined />,
                      label: (
                        <Link to="/generalsettingbooks">
                          Books General Settings
                        </Link>
                      ),
                    },
                    {
                      key: "/fyi-import",
                      icon: <CloudDownloadOutlined />,
                      label: <Link to="/fyi-import">FYI Bulk Import</Link>,
                    },
                    {
                      key: "/xcelify-extraction",
                      icon: <FileTextOutlined />,
                      label: (
                        <Link to="/xcelify-extraction">Xcelify Extraction</Link>
                      ),
                    },
                  ],
                }
              : null,

            isSuperAdmin()
              ? {
                  type: "group" as const,
                  label: "Reports",
                  children: [
                    {
                      key: "/biometric-report",
                      icon: <CloudOutlined />,
                      label: (
                        <Link to="/biometric-report">Biometric Report</Link>
                      ),
                    },
                    {
                      key: "/aml-report",
                      icon: <DeliveredProcedureOutlined />,
                      label: <Link to="/aml-report">AML Report</Link>,
                    },
                    {
                      key: "/practice-reports",
                      icon: <BarChartOutlined />,
                      label: (
                        <Link to="/practice-reports">Practice Reports</Link>
                      ),
                    },
                  ],
                }
              : null,
          ]}
        />
      ) : null}
    </>
  );
};
export default Sidemenus;
